import {BaseConverter} from '../../base/converters/base-converter.converter';
import {SecurityQuestionModel} from '../models/security-question.model';
import {SecurityQuestion} from '../../shared/DTO/securityQuestion';
import {Injectable} from '@angular/core';

@Injectable()
export class SecurityQuestionConverter extends BaseConverter<SecurityQuestionModel, SecurityQuestion> {
  convertToDto(model: SecurityQuestionModel): SecurityQuestion {
    return undefined;
  }

  convertToModel(dto: SecurityQuestion): SecurityQuestionModel {
    if (!dto) {
      return null;
    }
    let model: SecurityQuestionModel = new SecurityQuestionModel();

    model.id = dto.id;
    model.question = dto.question;
    return model;
  }

}
